// Relógio compartilhado dos contadores regressivos (MET-25).
//
// Armadilha que este arquivo existe para evitar: uma lista de 50 conversas com
// janela de 24h aberta criaria 50 `setInterval(1000)`. O ticker é UM só —
// os componentes assinam um store externo e o React re-renderiza quem depende.
//
// Store externo (e não `useState` num Provider) porque `useSyncExternalStore`
// dá o snapshot correto no primeiro render e desliga o intervalo sozinho quando
// o último contador sai da tela.

export interface Ticker {
  subscribe: (listener: () => void) => () => void;
  getSnapshot: () => number;
}

export function createTicker(intervalMs = 1000): Ticker {
  const listeners = new Set<() => void>();
  let now = Date.now();
  let handle: ReturnType<typeof setInterval> | null = null;

  const tick = () => {
    now = Date.now();
    for (const l of listeners) l();
  };

  return {
    subscribe(listener) {
      listeners.add(listener);
      // Primeiro assinante liga o intervalo; o último a sair desliga.
      if (handle === null) {
        now = Date.now();
        handle = setInterval(tick, intervalMs);
      }
      return () => {
        listeners.delete(listener);
        if (listeners.size === 0 && handle !== null) {
          clearInterval(handle);
          handle = null;
        }
      };
    },
    getSnapshot() {
      return now;
    },
  };
}

/**
 * Ticker padrão da aplicação. Existe para que um `<CountdownTimer>` fora de
 * qualquer Provider ainda assim compartilhe o mesmo intervalo com os outros.
 */
export const globalTicker = createTicker();

/** Ticker parado, para testes determinísticos: `now` fixo, zero intervalos. */
export function createFrozenTicker(now: number): Ticker {
  return {
    subscribe: () => () => {},
    getSnapshot: () => now,
  };
}
